import { render } from "./InventoryCategoryTable.vue?vue&type=template&id=b8e1ab5a&scoped=true"
import script from "./InventoryCategoryTable.vue?vue&type=script&lang=js"
export * from "./InventoryCategoryTable.vue?vue&type=script&lang=js"

import "./InventoryCategoryTable.vue?vue&type=style&index=0&id=b8e1ab5a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8e1ab5a"]])

export default __exports__